import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ColumnFilter } from "security-app/components/common";
const columnsWithFilter = ["type"];
function ListHeader({ ownerOptions, setCurrentOptions, filters, setFilters }) {
  const { t } = useTranslation("enterprise_security_events");
  const filtersByColumn = useMemo(
    () => ownerOptions.reduce((acc, owner) => {
      Object.entries(owner).filter(([key, _]) => columnsWithFilter.includes(key)).forEach(([key, value]) => {
        if (value == null) return;
        if (!acc[key]) acc[key] = [];
        const labelValue = value.toString();
        const filterValue = value.toString();
        const valueType = typeof value;
        if (!acc[key].find((filter) => filter.value.toString() === filterValue)) {
          acc[key].push({ label: labelValue, value: filterValue, type: valueType });
        }
      });
      return acc;
    }, {}),
    [ownerOptions]
  );
  const applyFilters = (filterKey, filterValues) => {
    const auxFilters = { ...filters };
    if (!filterValues || filterValues.length === 0) delete auxFilters[filterKey];
    else auxFilters[filterKey] = filterValues;
    setFilters(auxFilters);
    if (Object.keys(auxFilters).length) {
      setCurrentOptions(
        ownerOptions.filter(
          (option) => filterValues.map(({ value }) => value).includes(option[filterKey])
        )
      );
    } else {
      setCurrentOptions(ownerOptions);
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("colgroup", null, /* @__PURE__ */ React.createElement("col", { style: { width: 32 } }), /* @__PURE__ */ React.createElement("col", { style: { width: "70%" } }), /* @__PURE__ */ React.createElement("col", { style: { width: "auto" } })), /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null), /* @__PURE__ */ React.createElement("th", null, t("users_list_header.name")), /* @__PURE__ */ React.createElement("th", null, /* @__PURE__ */ React.createElement(
    ColumnFilter,
    {
      filterBy: "type",
      type: "text",
      filterData: filtersByColumn == null ? void 0 : filtersByColumn.type,
      appliedFilters: filters,
      onClose: applyFilters
    },
    t("users_list_header.type")
  )))));
}
export default ListHeader;
